export default {
  SET_AFFECTED_APP: 'SET_AFFECTED_APP',

}
